import { useI18n } from '@change-corgi/core/react/i18n';

import { useImpactStoryPageData } from 'src/app/pages/impactStory/pageContext';

type Result = ModelHookResult<{
	starterQuote: string;
	quoteImage: string;
	byLine: string;
}>;

export function useStarterQuoteContainer(): Result {
	const {
		data: {
			petition: {
				user: { displayName },
			},
			featureConfig: {
				story: { starterQuote, quoteImage },
			},
		},
	} = useImpactStoryPageData();
	const { translate } = useI18n();

	const petitionStarter = translate('corgi.impact_story.petition_starter');

	return {
		data: {
			starterQuote,
			quoteImage,
			byLine: displayName ? `${displayName}, ${petitionStarter}` : petitionStarter,
		},
	};
}
